<button
  *ngIf="pluginName === 'microsoft' || pluginName === ''"
  nz-button
  nzType="primary"
  (click)="login()"
  class="delta"
>
  <div nz-flex nzAlign="center" nzGap="8px">
    <span nz-icon nzType="ng-zorro:xbox"></span>
    <ng-container *ngIf="pluginName === ''">{{ text }}</ng-container>
    <ng-container *ngIf="pluginName === 'microsoft'">
      Logged in Xbox
      <span nz-icon nzType="ng-zorro:success" class="success-icon"></span>
    </ng-container>
  </div>
</button>
